// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @constants
const cardImageIds= {
    cardImageIdsPack1: [
        'B.500.003.001',
        'B.500.003.002',
        'B.500.003.003',
        'B.500.003.004',
    ],
    cardImageIdsPack2: [
        'B.500.003.005',
        'B.500.003.006',
        'B.500.003.007',
        'B.500.003.008',
    ],
    cardImageIdsPack3: [
        'B.500.003.009',
        'B.500.003.010',
        'B.500.003.011',
        'B.500.003.012',
    ],
    cardImageIdsPack4: [
        'B.500.003.013',
        'B.500.003.014',
        'B.500.003.015',
        'B.500.003.016',
    ],
};

class HireCardRevolvingStep2 extends React.Component {

    render() {
        const {
            extraImage,
            immHireCardImageSelector,
            immHireCardNameSelector,
            immHireCardRevolving,
        } = this.props;

        return (
            <article className="hire-card-revolving__step-two">
                <FormattedText
                    className="hire-card-revolving__step-title"
                    value="hireCardRevolving-step2Title"
                />
                <HireCardImageSelector
                    cardImageIds={cardImageIds[`cardImageIdsPack${immHireCardRevolving.get('pack')}`]}
                    extraClass="hire-card-revolving__card-image-selector"
                    extraImage={extraImage}
                    immHireCardImageSelector={immHireCardImageSelector}
                />
                <HireCardNameSelector
                    borderTop={true}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
            </article>
        );
    }
}

HireCardRevolvingStep2.propTypes = {
    extraImage: PropTypes.string,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardRevolving: PropTypes.object.isRequired,
};

module.exports = HireCardRevolvingStep2;
